import { useEffect, useRef } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { convertBaseItemToMediaItem } from 'utils/media'
import { getItemFromLocalStorage } from 'utils/localStorage'
import {
  DEFAULT_MEDIA_DURATION,
  EXTERNAL_MEDIA_QUERY_PARAM,
  EXTERNAL_MEDIA_STORAGE_KEY,
  NEW_PROJECT_ID_PARAM
} from 'consts'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { dispatch } from 'store'
import { useVisualMediaPlacement } from 'hooks/timeline/useVisualMediaPlacement'

export const useExternalMedia = () => {
  const [searchParams] = useSearchParams()
  const { projectId } = useParams()
  const { width: projectDefaultWidth, height: projectDefaultHeight } =
    useSelector(projectDataSelectors.defaultDimensions)
  const getPlacement = useVisualMediaPlacement()
  const didInsertRef = useRef(false)

  useEffect(() => {
    if (didInsertRef.current) return

    const mediaId = searchParams.get(EXTERNAL_MEDIA_QUERY_PARAM)
    const mediaItem = getItemFromLocalStorage(EXTERNAL_MEDIA_STORAGE_KEY)

    if (
      projectId !== NEW_PROJECT_ID_PARAM ||
      !mediaId ||
      !mediaItem ||
      mediaItem.mediaId !== mediaId
    )
      return

    didInsertRef.current = true

    const duration = mediaItem.duration ?? DEFAULT_MEDIA_DURATION
    const placement = getPlacement(duration)
    const preparedItem = convertBaseItemToMediaItem(
      mediaItem,
      placement.startTime,
      {
        width: projectDefaultWidth,
        height: projectDefaultHeight
      },
      placement.zIndex
    )
    dispatch(projectDataThunks.addMediaItems({ value: [preparedItem] }))
  }, [
    getPlacement,
    projectDefaultHeight,
    projectDefaultWidth,
    projectId,
    searchParams
  ])
}
